// extracted by mini-css-extract-plugin
module.exports = {"App":"home_App__3uQAk","mainContainer":"home_mainContainer__3qlDa","subredditContainer":"home_subredditContainer__2kMQp"};